import React from 'react';
import TopBar from "./components/TopBar/TopBar";
import Home from "./pages/home/Home";
import LoginForm from './components/LoginForm/LoginForm';
import { ReactSession}  from 'react-client-session';
import Toast from './components/Toast/Toast'
import errorIcon from './assets/images/error.svg';
import md5 from 'md5';

require('dotenv').config();

function App() {

  ReactSession.setStoreType("localStorage");

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [ page, setPage ] = React.useState('');
  const [ answers, setAnswers ] = React.useState({page:page,subjects:null});
  const [isShowLogin, setIsShowLogin] = React.useState(true);
  const [ admin, setAdmin ] = React.useState(ReactSession.get("username"));
  const [toastList, setToastList] = React.useState([]);

  /************************* HANDLE METHODS ************************************/

  const handleLoginClick = () => {
    setIsShowLogin((isShowLogin) => !isShowLogin);
  };

  const handleLogoutClick = () => {
        ReactSession.set("username", '');
        setAdmin(false);
  };

  function handleSubmitPage(e) {
    e.preventDefault();
    
    const formData = new FormData(e.target);
    setPage(formData.get('page'));

    const formDataSession = new FormData();
    formDataSession.append('user',ReactSession.get("username"));

    //Verify if session is alive
    fetch(`${SERVER_URL}/session.php`,{
        method: 'POST',
        body: formDataSession
    })
    .then(res => res.json())
    .then(result => {
      if (!result.success) {
        setAdmin(false);
      } else {
        // console.log(result.message);
      }
    })

  }

  function handleSubmitLogin(e) {
    e.preventDefault();
    
    const formData = new FormData(e.target);

    fetch(`${SERVER_URL}/login.php`,{
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(result => {
      if (result.success) {
        setAdmin(true);
        setIsShowLogin(true);

        ReactSession.set("username", md5(formData.get('username').toUpperCase()));
        
        // console.log(result.message);
      } else {
        // console.log(result.message);
        ReactSession.set("username", '');
        setAdmin(false);
        showToast();
      }
    })

  }

  const showToast = () => {
    setToastList([{
           id: 1000,
           title: 'Login',
           description: 'Usuário e/ou senha inválidos.',
           backgroundColor: '#d9534f',
          icon: errorIcon

    }])
}

  /************************* DATABASE METHODS ************************************/

  function AddAnswer(subject, answerId, answer, image) {

    var formData = new FormData();
    formData.append('insert',1);
    formData.append('page',page);
    formData.append('subject',subject);
    formData.append('answerId',answerId);
    formData.append('answer',answer);
    formData.append('image',image);

    fetch(`${SERVER_URL}/answers.php`,{
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(result => {
      if (result.success) {
        setAnswers({...answers});
      }
    
    }).catch(err => console.log(err))

  }


  function UpdateAnswer(answerObj, subject, answerId, answer, image) {

        var formData = new FormData();
        formData.append('update',1);
        formData.append('page',page);
        formData.append('subject',subject);
        formData.append('answerId',answerId);
        formData.append('answer',answer);
        formData.append('image',image);
    
        fetch(`${SERVER_URL}/answers.php`,{
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(result => {
          
          if (result.success) {
            answerObj.answer = answer;
            setAnswers({...answers});
          }
        
        }).catch(err => console.log(err))
    
      }


  function DeleteAnswer(answersArr, subject, answerId) {

        var formData = new FormData();
        formData.append('delete',1);
        formData.append('page',page);
        formData.append('subject',subject);
        formData.append('answerId',answerId);
    
        fetch(`${SERVER_URL}/answers.php`,{
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(result => {
          
          if (result.success) {
            answersArr= answersArr.filter(ans => ans.id !== answerId);
            setAnswers({...answers});
          }
        
        }).catch(err => console.log(err))
    
      }

  function listAnswers() {

    var formData = new FormData();
    formData.append('select',1);
    formData.append('page',page);

    fetch(`${SERVER_URL}/answers.php`,{
        method: 'POST',
        body: formData
    })
    .then(res => res.json())
    .then(result => {setAnswers(result)})

  }

  React.useEffect(() => {    
    listAnswers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[page]);


  /************************* RENDER PAGE ************************************/
  return (
    <>
      <TopBar 
        admin = {admin}
        handleSubmitPage={handleSubmitPage} 
        handleLoginClick={handleLoginClick} 
        handleLogoutClick={handleLogoutClick}/>
      <LoginForm 
        isShowLogin={isShowLogin} 
        handleSubmitLogin={handleSubmitLogin}/>
      <Home 
        admin = {admin}
        page={page} 
        answers={answers} 
        refreshAnswers={(ans) => setAnswers(ans)} 
        AddAnswer={AddAnswer}
        UpdateAnswer={UpdateAnswer} 
        DeleteAnswer={DeleteAnswer} 
      />
      <Toast 
          toastList={toastList}
          position='bottom-left'
          autoDelete={true}
          dismissTime={3000}
      />
    </>
  );
}

export default App;
